import React, { useEffect, useState } from "react";
import ChooseImage from "./ChooseImage";
import ColorPicker from "./ColorPicker";
import {useGlobalState } from "../contexts/GlobalStateContext";


function toTitleCase(inputString) {
  return inputString.replace(/\w\S*/g, function (word) {
    return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
  });
}

async function updateUsername(newUserName, logOut, resetGlobalState ) {
    try {
      const response = await fetch(
        `/php/updateUsername.php?cacheBuster=${Date.now()}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ username: newUserName }),
        }
      );
     if (response.status === "error"){
        logOut();
        resetGlobalState();
      } else if (!response.ok)
        throw new Error(`Username update error: ${response.statusText}`);

    } catch (error) {
      console.error("Username update error:", error);
    }
  }

async function updateName(newName, abbreviation, logOut, resetGlobalState ) {
  try {
    const response = await fetch(
      `/php/updateName.php?cacheBuster=${Date.now()}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ newName, initials: abbreviation }),
      }
    );
    if (response.status === "error"){
      logOut();
      resetGlobalState();
    } else if (!response.ok)
      throw new Error(`Name update error: ${response.statusText}`);
  } catch (error) {
    console.error("Name update error:", error);
  }
}


async function updateLink(newLink, logOut, resetGlobalState ) {
  try {
    const response = await fetch(
      `/php/updateLink.php?cacheBuster=${Date.now()}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ newLink }),
      }
    );
    if (response.status === "error"){
      logOut();
      resetGlobalState();
    } else if (!response.ok)
      throw new Error(`Link update error: ${response.statusText}`);
  } catch (error) {
    console.error("Link update error:", error);
  }
}

async function updateTheme(newTheme, newBG, logOut, resetGlobalState ) {
  try {
    const response = await fetch(
      `/php/updateTheme.php?cacheBuster=${Date.now()}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ newTheme, newBG }),
      }
    );
    if (response.status === "error"){
      logOut();
      resetGlobalState();
    } else if (!response.ok)
      throw new Error(`Theme update error: ${response.statusText}`);
  } catch (error) {
    console.error("Theme update error:", error);
  }
}

async function uploadCroppedPP(profileImageURI, logOut, resetGlobalState ) {
  const button = document.getElementById("saveUpdates");
  // Disable the button to prevent multiple clicks
  button.disabled = true;

  let dots = 0;

  // Function to update the button text with dots
  const updateTextWithDots = () => {
    button.textContent = "Updating" + ".".repeat(dots % 4);
    dots++;
  };

  // Start the interval to update the text with dots
  const intervalId = setInterval(updateTextWithDots, 500);

  try {
    // Convert the data URI to a Blob object
    const response = await fetch(profileImageURI);
    const imageBlob = await response.blob();

    // Create a FormData object
    const formData = new FormData();

    // Append the image Blob to the FormData object
    formData.append("image", imageBlob, "croppedImage.jpg");

    // Send a POST request to upload.php with the FormData object
    const uploadResponse = await fetch("/php/uploadProfilePicture.php", {
      method: "POST",
      body: formData,
    });

    // Check if the request was successful
    if (uploadResponse.status === "error"){
      logOut();
      resetGlobalState();
    } else if (uploadResponse.ok) {
      console.log("Image uploaded");
      
    } else {
      // Get the response content as text for more details
      const responseText = await uploadResponse.text();

      // Throw an error with detailed information
      throw new Error(
        `HTTP Error: ${uploadResponse.status} ${uploadResponse.statusText}. Response content: ${responseText}`
      );
    }
  } catch (error) {
    // Log the error message to the console
    console.error("Upload failed:", error.message);
  } finally {
    // Clear the interval and reset the button text
    clearInterval(intervalId);
    button.textContent = "Update Complete";
  }
}

async function uploadCroppedCover(CoverImageURI, logOut, resetGlobalState ) {
  const button = document.getElementById("saveUpdates");
  let dots = 0;
  // Disable the button to prevent multiple clicks
  button.disabled = true;

  // Function to update the button text with dots
  const updateTextWithDots = () => {
    button.textContent = "Updating" + ".".repeat(dots % 4);
    dots++;
  };

  // Start the interval to update the text with dots
  const intervalId = setInterval(updateTextWithDots, 500);

  try {
    // Convert the data URI to a Blob object
    const response = await fetch(CoverImageURI);
    const imageBlob = await response.blob();

    // Create a FormData object
    const formData = new FormData();

    // Append the image Blob to the FormData object
    formData.append("image", imageBlob, "croppedImage.jpg");

    // Send a POST request to upload.php with the FormData object
    const uploadResponse = await fetch("/php/uploadCoverImg.php", {
      method: "POST",
      body: formData,
    });

    // Check if the request was successful
    if (uploadResponse.status === "error"){
      logOut();
      resetGlobalState();
    } else if (uploadResponse.ok) {
      console.log("Image uploaded");
    } else {
      // Get the response content as text for more details
      const responseText = await uploadResponse.text();

      // Throw an error with detailed information
      throw new Error(
        `HTTP Error: ${uploadResponse.status} ${uploadResponse.statusText}. Response content: ${responseText}`
      );
    }
  } catch (error) {
    console.error("Error:", error);
  } finally {
    // Clear the interval and reset the button text
    clearInterval(intervalId);
    button.textContent = "Update Complete";
  }
}

async function uploadBoth(coverImageURI, profileImageURI,logOut, resetGlobalState ) {
  const button = document.getElementById("saveUpdates");
  // Disable the button to prevent multiple clicks
  button.disabled = true;
  let dots = 0;

  // Function to update the button text with dots
  const updateTextWithDots = () => {
    button.textContent = "Updating" + ".".repeat(dots % 4);
    dots++;
  };

  // Start the interval to update the text with dots
  const intervalId = setInterval(updateTextWithDots, 500);

  try {
    // Convert the data URI to a Blob object
    const response = await fetch(coverImageURI);
    const imageBlob = await response.blob();

    // Create a FormData object
    const formData = new FormData();

    // Append the image Blob to the FormData object
    formData.append("image", imageBlob, "croppedImage.jpg");

    // Send a POST request to uploadCoverImg.php with the FormData object
    const uploadResponse = await fetch("/php/uploadCoverImg.php", {
      method: "POST",
      body: formData,
    });

    // Check if the request was successful
    if (uploadResponse.status === "error"){
      logOut();
      resetGlobalState();
    } else if (uploadResponse.ok) {
      console.log("Cover image uploaded");
      await uploadCroppedPP(profileImageURI, logOut, resetGlobalState );
    } else {
      // Get the response content as text for more details
      const responseText = await uploadResponse.text();

      // Throw an error with detailed information
      throw new Error(
        `HTTP Error: ${uploadResponse.status} ${uploadResponse.statusText}. Response content: ${responseText}`
      );
    }
  } catch (error) {
    console.error("An error occurred during the upload process:", error);
  } finally {
    // Clear the interval and reset the button text
    clearInterval(intervalId);
    button.textContent = "Update Complete";
  }
}

const UpdateProfileModal = ({ user, onClose }) => {
  const [newFullName, setNewFullName] = useState(user.fullName);
  const [abbreviation, setAbbreviation] = useState(user.initials);
  const [newUsernameInput, setNewUsernameInput] = useState(user.username);
  const [usernameAvailable, setUsernameAvailable] = useState(false);
  const [checkingUsername, setCheckingUsername] = useState(false);
  const [link, setLink] = useState(user.link);
  const [profileImg, setProfileImg] = useState(null);
  const [coverImg, setCoverImg] = useState(null);
  const [themeChanged, setThemeChanged] = useState(false);
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const [showCoverImageModal, setShowCoverImageModal] = useState(false);
  const [showProfileImageModal, setShowProfileImageModal] = useState(false);
  const [themeColor, setThemeColor] = useState(user.theme);
  const [complementaryColor, setComplementaryColor] = useState(user.text_bg);
  const { globalState, setGlobalState, logOut, resetGlobalState } = useGlobalState();
    const [showLinkInput, setShowLinkInput] = useState(false);

  // Function to calculate black or white based on contrast
  const getContrastColor = (hex) => {
    // Convert hex to RGB
    let r = parseInt(hex.substring(1, 3), 16);
    let g = parseInt(hex.substring(3, 5), 16);
    let b = parseInt(hex.substring(5, 7), 16);

    // Calculate luminance (Perceived brightness)
    let luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    // If luminance is low, return white (#FFFFFF), else return black (#000000)
    return luminance < 0.5 ? "#FFFFFF" : "#000000";
  };

  // Update contrast color whenever themeColor changes
  useEffect(() => {
    setComplementaryColor(getContrastColor(themeColor));
    setThemeChanged(true);
  }, [themeColor]);

  useEffect(() => {
    if (!newUsernameInput) return;

    const handler = setTimeout(async () => {
      if (/[^a-zA-Z0-9_]/.test(newUsernameInput)) {
        setUsernameAvailable(false);
        return;
      }

      setCheckingUsername(true);
      try {
        const res = await fetch("/php/checkUsername.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: `username=${encodeURIComponent(newUsernameInput)}`,
        });
        const data = await res.json();
        setUsernameAvailable(data.available);
      } catch (err) {
        console.error("Error checking username:", err);
        setUsernameAvailable(false);
      } finally {
        setCheckingUsername(false);
      }
    }, 500);

    return () => clearTimeout(handler);
  }, [newUsernameInput]);

  const handleSaveUpdates = async () => {
    let updatesMade = false;
    let newAvatarVersion = user.avatar_version;
    let newCoverVersion = user.coverImg_version;
  
    if (newFullName !== globalState.user.fullName) {
      await updateName(newFullName, abbreviation, logOut, resetGlobalState );
      updatesMade = true;
    }
  
    await delay(100);
  
    if (newUsernameInput && usernameAvailable && newUsernameInput !== globalState.user.username) {
      await updateUsername(newUsernameInput, logOut, resetGlobalState );
      updatesMade = true;
    }
  
    await delay(100);
  
    if (link !== globalState.user.link) {
      await updateLink(link, logOut, resetGlobalState );
      updatesMade = true;
    }
  
    await delay(100);
  
    if (themeChanged) {
      await updateTheme(themeColor, complementaryColor, logOut, resetGlobalState );
      updatesMade = true;
    }
  
    if (profileImg || coverImg) {
      if (profileImg && coverImg) await uploadBoth(coverImg, profileImg, logOut, resetGlobalState );
      else if (profileImg) await uploadCroppedPP(profileImg, logOut, resetGlobalState );
      else if (coverImg) await uploadCroppedCover(coverImg, logOut, resetGlobalState );
  
      if (profileImg) newAvatarVersion += 1;
      if (coverImg) newCoverVersion += 1;
  
      updatesMade = true;
    }
  
    if (updatesMade) {
      const updatedUser = {
        ...user,
        fullName: newFullName || user.fullName,
        initials: abbreviation || user.initials,
        username: newUsernameInput && usernameAvailable ? newUsernameInput : user.username,
        theme: themeColor || user.theme,
        text_bg: complementaryColor || user.text_bg,
        avatar_version: newAvatarVersion,
        coverImg_version: newCoverVersion,
        link: link,
      };
  
      setGlobalState((prev) => ({
        ...prev,
        user: updatedUser,
      }));
  
      const finalUsername = updatedUser.username;
      window.history.pushState(null, '', `/@${finalUsername}`);
      onClose();
    }
  };
  

  useEffect(() => {
    if (!newFullName.trim()) {
      setAbbreviation("");
      return;
    }

    setAbbreviation(
      newFullName
        .split(" ")
        .filter((word) => word)
        .map((word) => word[0])
        .slice(0, 8)
        .join("")
        .toUpperCase()
    );
  }, [newFullName]);

  const handleCoverImgCrop = (croppedImage) => {
    // Set the cropped image as the source
    setCoverImg(croppedImage);
    setShowCoverImageModal(false);
  };

  const handleProfilePicCrop = (croppedImage) => {
    // Set the cropped image as the source
    setProfileImg(croppedImage);
    setShowProfileImageModal(false);
  };

  const handleSaveLink = () => {
    if (link === ""){
      setLink(null);
    }
    setShowLinkInput(false); // Hide the link input after saving
  };

  return (
    <>
      {showLinkInput && (
        <div id="add_link" className="popup" style={{ display: "block" }}>
          <span
            className="closeLink"
            onClick={() => setShowLinkInput(false)} // Close the popup
            style={{ cursor: "pointer" }} // Optional: make sure the close button has pointer cursor for better UX
          >
            ×
          </span>
          <br />
          <span style ={{ textAlign: "left" }} >Link:</span>
          <input
            type="text"
            id="linkInput"
            className="fullTextbox"
            autoComplete="off"
            placeholder="Insert link here..."
            value={link || ""} // Bind input value to `link` state
            onChange={(e) => setLink(e.target.value)} // Update `link` state on input change
          />
          <br />
          <button
            className="save"
            id="saveLink"
            onClick={handleSaveLink} // Call handleSaveLink on button click
          >
            Save
          </button>
        </div>
      )}
      {showProfileImageModal && (
        <ChooseImage
          onClose={() => setShowProfileImageModal(false)}
          onCrop={handleProfilePicCrop}
          type="ProfileImg"
        />
      )}
      {showCoverImageModal && (
        <ChooseImage
          onClose={() => setShowCoverImageModal(false)}
          onCrop={handleCoverImgCrop}
          type="CoverImg"
        />
      )}
      <div id="UpdateUI" className="w3-modal">
        <div className="w3-modal-content w3-animate-bottom">
          <header className="w3-container w3-teal">
            <div className="toggle_row">
              <div className="columnA">
                <span style={{ fontSize: 20, padding: 10 }}>
                  Update Profile
                </span>
              </div>
              <span
                onClick={onClose}
                className="w3-button w3-display-topright"
                style={{
                  fontSize: 40,
                  marginRight: -5,
                  float: "right",
                }}
              >
                &times;
              </span>
            </div>
          </header>

          <div className="w3-container">
            <div className="draftContainer">
              <img
                src={
                  coverImg ||
                  `/cover/${user.user_id}.jpg?v=${globalState.user.coverImg_version}`
                }
                id="cover_display"
                alt="Cover"
                className="thumbnail"
              />

              <div
                className="bottom-left"
                onClick={() => setShowProfileImageModal(true)}
                style={{backgroundColor:  themeColor || "#333", color: complementaryColor}}
              >
                Profile Picture
              </div>

              <div className="top-left">
                <img
                alt = "Profile Icon"
                  id="dp_display"
                  className="dp"
                  width="25px"
                  src={
                    profileImg ||
                    `/profile_pics/${user.user_id}.jpg?v=${globalState.user.avatar_version}`
                  }
                />
                <span id="new_username_display" style={{backgroundColor:  themeColor || "#333", color: complementaryColor, padding: '0 5px' }}>
                  {newUsernameInput}
                </span>
              </div>

              <div className="top-right">
                <ColorPicker onColorSelect={setThemeColor} />
              </div>

              <div
              style={{backgroundColor:  themeColor || "#333", color: complementaryColor}}
                className="bottom-right"
                onClick={() => setShowCoverImageModal(true)}
              >
                Cover Image
              </div>

              <div className="centered">
                <span
                  className="abvri3"
                  style={{ color: themeColor }}
                >
                  {abbreviation}
                </span>
                <br />
                <span
                  className="fullForm3"
                  style={{
                    backgroundColor: complementaryColor || user.text_bg,
                    color: themeColor || user.theme,
                  }}
                >
                  {newFullName}
                </span>
              </div>

              <span
                className="link"
                id="profile_link"
                onClick={() => setShowLinkInput(true)}
              >
                &#128279;
              </span>
            </div>

            <div className="logInTextContainer">
              

              <div className="input-container">
                <span
                  style={{
                    fontSize: 15,
                    display: "inline-block",
                    width: 100,
                    margin: "20px 0",
                  }}
                >
                  Family Name:
                </span>
                <input
                  type="text"
                  placeholder={globalState.user.fullName}
                  value={newFullName}
                  onChange={(e) => setNewFullName(toTitleCase(e.target.value))}
                />
              </div>
            </div>

          </div>

          <div className="centered-buttons">
            <button style={{ backgroundColor: "gray" }} onClick={onClose}>
              Cancel
            </button>
            <button id = "saveUpdates" onClick={handleSaveUpdates}>Update</button>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateProfileModal;
